import LocationPermission from "@mapmycustomers/shared/enum/LocationPermission";

import PermissionStatus from "../enum/PermissionStatus";
import DeviceSignals from "../types/DeviceSignals";
import DeviceStatuses from "../types/DeviceStatuses";

import { ANDROID_PLATFORM } from "./consts";

const toPermissionStatus = (reported: boolean | null, applicable: boolean): PermissionStatus => {
  if (!applicable) {
    return PermissionStatus.NOT_APPLICABLE;
  }

  if (reported === true) {
    return PermissionStatus.GRANTED;
  }

  return reported === false ? PermissionStatus.DENIED : PermissionStatus.UNKNOWN;
};

// N/A comes from a missing Mileage Tracker or an Android device; anything else unreported is Unknown.
const getDeviceStatuses = (
  signals: DeviceSignals,
  hasMileageTracking: boolean
): DeviceStatuses => ({
  // Offline sync uses it too, so it applies to every rep; Android has no such setting.
  backgroundRefresh: toPermissionStatus(
    signals.backgroundRefreshEnabled,
    signals.platform !== ANDROID_PLATFORM
  ),
  location: signals.locationPermission ?? PermissionStatus.UNKNOWN,
  motion: toPermissionStatus(signals.motionEnabled, hasMileageTracking),
  notifications: toPermissionStatus(signals.notificationsEnabled, true),
  // Drives check-in accuracy for every rep; the server keeps a stale value once Location is Off.
  preciseLocation:
    signals.locationPermission === LocationPermission.OFF
      ? PermissionStatus.UNKNOWN
      : toPermissionStatus(signals.preciseLocationEnabled, true),
});

export default getDeviceStatuses;
